import { render, staticRenderFns } from "./CurrentPackage.vue?vue&type=template&id=61f5efa4&"
import script from "./CurrentPackage.vue?vue&type=script&lang=js&"
export * from "./CurrentPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports